var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-dialog',{attrs:{"title":"文件预览","size":"full","visible":_vm.showPreview},on:{"update:visible":function($event){_vm.showPreview=$event}}},[_c('iframe',{staticStyle:{"width":"100%","height":"600px"},attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }